import React from 'react'

const GDPR = () => {
  return (
    <svg
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill={'rgba(0, 0, 0, 0.57)'}
      style={{
        display: 'inline-block',
        verticalAlign: 'middle',
        marginRight: '6px'
      }}
    >
      <g>
        <path fill="none" d="M0,0h24v24H0V0z" />
      </g>
      <g>
        <polygon points="18,9 16.59,7.58 10,14.17 7.41,11.59 6,13 10,17" />
        <path d="M19,3L19,3h-4.18C14.4,1.84,13.3,1,12,1c-1.3,0-2.4,0.84-2.82,2H5h0C4.86,3,4.73,3.01,4.6,3.04 C4.21,3.12,3.86,3.32,3.59,3.59c-0.18,0.18-0.33,0.4-0.43,0.64C3.06,4.46,3,4.72,3,5v14c0,0.27,0.06,0.54,0.16,0.78 c0.1,0.24,0.25,0.45,0.43,0.64c0.27,0.27,0.62,0.47,1.01,0.55C4.73,20.99,4.86,21,5,21h0h14h0c1.1,0,2-0.9,2-2V5 C21,3.9,20.1,3,19,3z M12,2.75c0.41,0,0.75,0.34,0.75,0.75c0,0.41-0.34,0.75-0.75,0.75c-0.41,0-0.75-0.34-0.75-0.75 C11.25,3.09,11.59,2.75,12,2.75z M19,19H5V5h14V19z" />
      </g>

    </svg>
  )
}

export default GDPR



// WEBPACK FOOTER //
// ./src/components/User/icons/gdpr.js